import { Routes, Route } from "react-router-dom";
import App from "./App";
import EventsPage from "./pages/EventsPage";

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/eventos" element={<EventsPage />} />
    </Routes>
  );
}